module.exports = __webpack_public_path__ + "static/media/15UN-Habitat6.846d00bc.jpg";